import React, {Component} from 'react';
import {connect} from 'react-redux';
import RangeSetterWrapper from '../components/RangeSetterWrapper/RangeSetterWrapper';
import RangeSetterContainer from './RangeSetterContainer';
import {getApolloClient} from '../../../lib/graphQL/apolloClient';
import {
  UPSERT_NEST_TRIGGER_SETTINGS,
  DELETE_NEST_TRIGGER_SETTINGS,
  QUERY_NEST_TRIGGER_SETTINGS
} from '../../../lib/graphQL/nest/queries';
import {
  getDeviceTypeComponents,
  getInitialTriggerSettings,
  initializeTriggerEntities
} from '../../../lib/functions';
import {NestActions} from '../../../store/actionCreators';
import Store from '../../../store';



class SettingControllerContainer extends Component {

  changedTriggerEntities;

  componentDidMount() {
    window.saveSettings = () => {
      const nestState = Store.getState() && Store.getState().nest;
    
      if (nestState != null && nestState.awairQueryParams != null) {
        const initialTriggers = nestState.initialTriggerEntities;
        const changedTriggers = nestState.changedTriggerEntities;
        const targetId = nestState.targetId;
        const deviceUuid = nestState.awairQueryParams.deviceUuid;
        const deviceType = nestState.awairQueryParams.deviceType;
    
        if (initialTriggers != null && changedTriggers != null) {
          let deleteTriggerIds = [];
          let upsertTriggerSettings = [];
    
          Object.keys(changedTriggers).forEach(key => {
            if (!changedTriggers[key].isEnabled) {
              // Delete if changed is disabled and initial has triggerUuid
              initialTriggers[key].triggerUuid && deleteTriggerIds.push(initialTriggers[key].triggerUuid);
            } else {
              // Add || Update
              upsertTriggerSettings.push({
                deviceUuid,
                targetId,
                serviceProviderName: 'nest',
                eventType: 'FanOn',
                direction: 'RISING',
                comp: key.split('_')[0],
                onAt: changedTriggers[key].onAt
              });
            }
          });
    
          const allPromises = [];
    
          if (upsertTriggerSettings.length > 0) {
            allPromises.push(
              getApolloClient().mutate({
                mutation: UPSERT_NEST_TRIGGER_SETTINGS,
                variables: {
                  triggerSettings: upsertTriggerSettings
                }
              })
            );
          }
    
          if (deleteTriggerIds.length > 0) {
            allPromises.push(
              getApolloClient().mutate({
                mutation: DELETE_NEST_TRIGGER_SETTINGS,
                variables: {
                  triggerIds: deleteTriggerIds
                }
              })
            );
          }
    
          if (allPromises.length > 0) {
            NestActions.setLoading();
    
            Promise.all(allPromises)
              .then(res => {
                getApolloClient().query({
                  query: QUERY_NEST_TRIGGER_SETTINGS,
                  variables: {
                    deviceUuid,
                    targetId
                  },
                  fetchPolicy: 'network-only'
                })
                  .then(response => {
                    NestActions.unsetLoading();
                    let isV1 = false;
                    // Retrieve trigger settings to update triggerIds
                    const triggerSettings = response.data.getTriggerSettings;
                    const sensorComponents = getDeviceTypeComponents(deviceType);
                    const forInitialSensorComponents = sensorComponents.map((sensor) => {
                      if(sensor === 'voc_v1') {
                        isV1 = true;
                        return 'voc';
                      }
                      return sensor;
                    });
                    const initialTriggerEntities = getInitialTriggerSettings(triggerSettings, forInitialSensorComponents, isV1);
                    
                    // Reset trigger entities to the updated values to prepare for next trigger setting/s
                    NestActions.setInitialTriggerEntities(initialTriggerEntities);
                    NestActions.setChangedTriggerEntities(initialTriggerEntities);
                    NestActions.convertToInitialValue(false);
                    NestActions.hideCompleteModal({isClosed: false, text: 'Saved!'});
                  })
                  .catch(error => {
                    NestActions.unsetLoading();
                    alert('Failed to retrieve settings.\nPlease try again later.');
                  });
              })
              .catch(error => {
                NestActions.unsetLoading();
                alert('Failed to set notification.\nPlease try again later.');
              });
          } else {
            NestActions.setLoading();
            setTimeout(() => {
              NestActions.unsetLoading();
              NestActions.hideCompleteModal({isClosed: false, text: 'Saved!'});
            }, 500);
          }
        }
      }
    };
  }

  shouldComponentUpdate(nextProps) {
    if((this.props.isValueInitialized === true) && (nextProps.isValueInitialized === false)) {
      return false;
    }
    return true;
  }

  toggleSwitch = (component, isEnabled) => {
    if(component === 'voc_v1') {
      component = 'voc';
    }
    this.changedTriggerEntities = {
      ...this.changedTriggerEntities,
      [component]: {
        ...this.changedTriggerEntities[component],
        isEnabled
      }
    };
    NestActions.setChangedTriggerEntities(this.changedTriggerEntities);
  };

  onRangeMouseUp = (event, component, rangeValue) => {
    const min = event.target.min;
    const max = event.target.max;
    const value = event.target.value;
    event.target.parentNode.firstChild.style.backgroundSize = `${(value - min) * 100 / (max - min)}% 100%`;

    this.changedTriggerEntities = {
      ...this.changedTriggerEntities,
      [component]: {
        ...this.changedTriggerEntities[component],
        onAt: parseInt(rangeValue, 10)
      }
    };
    NestActions.setChangedTriggerEntities(this.changedTriggerEntities);
  }

  render() {
    const {triggerSettings, deviceType, isValueInitialized} = this.props;
    let isV1 = false;
    const sensorComponents = getDeviceTypeComponents(deviceType);
    const forInitialSensorComponents = sensorComponents.map((sensor) => {
      if(sensor === 'voc_v1') {
        isV1 = true;
        return 'voc';
      }
      return sensor;
    });
    let initialTriggerEntities = getInitialTriggerSettings(triggerSettings, forInitialSensorComponents, isV1);
    if(isValueInitialized) {
      initialTriggerEntities = initializeTriggerEntities(initialTriggerEntities, deviceType);
    }
    this.changedTriggerEntities = {...initialTriggerEntities};
    NestActions.setInitialTriggerEntities(initialTriggerEntities);
    NestActions.setChangedTriggerEntities(this.changedTriggerEntities);

    const rangeSetterElements = sensorComponents.map((sensorComponent, index) => (
      <RangeSetterContainer forInitialAirType={sensorComponent}
                            airType={forInitialSensorComponents[index]}
                            isEnabled={initialTriggerEntities[forInitialSensorComponents[index]].isEnabled}
                            onAt={initialTriggerEntities[forInitialSensorComponents[index]].onAt}
                            onChangeIndex={this.changeIndex}
                            onToggleSwitch={this.toggleSwitch}
                            onRangeMouseUp={this.onRangeMouseUp}
                            key={sensorComponent}/>
    ));

    return (
      <RangeSetterWrapper>
        {rangeSetterElements}
      </RangeSetterWrapper>
    );
  }
}

export default connect(
  ({nest}) => ({
    isValueInitialized: nest.isValueInitialized
  }),
  () => ({})
)(SettingControllerContainer);


// WEBPACK FOOTER //
// ./src/app/nest/containers/SettingControllerContainer.js